import { fetch_all as v3fetch_all, fetch_one as v3fetch_one } from "./server_helper";
import { getCookie, setCookie } from 'react-use-cookie';

let api_url: string = 'https://api.cribeon.io';

export async function fetchAll<Type>(
  url: string,
  params: unknown,
  login?: { auth_token: string, email: string, get_domain?: string }
) {
  return new Promise<Type[]>((resolve, reject) => {
    if (login) {
      v3fetch_all<Type>(
        url,
        params,
        (obs, complete_data) => {
          resolve(obs);
        },
        (e) => {
          reject(new Error("Something went wrong"));
        },
        login,
      );
    } else {
      reject(new Error("User is not logged in"));
    }
  });
}

export async function fetchAllWithCount<Type>(
  url: string,
  params: unknown,
  login?: { auth_token: string, email: string, get_domain?: string }
) {
  return new Promise<{count: number; result: Type[]}>((resolve, reject) => {
    let h = {};
    if (!!login) {
      h = {
        "Auth-Token": login.auth_token,
        "Auth-Email": login.email
      };
    }

    fetch(`${api_url}${url}`, {
      method: "POST",
      cache: "no-cache",
      headers: {
        ...((params instanceof FormData) ? {} : { "Content-Type": "application/json" }),
        "X-KANGA-KEY": "nwuziog6JX0J9M", // ENV?
        ...h
      },
      referrerPolicy: "no-referrer",
      body: (params instanceof FormData) ? params : JSON.stringify(params),
    })
    .then(res => res.json())
    .then(e => {
      if (e.success) {
        resolve(e.data);
      } else {
        if (e.data === 'not_authenticated') {
          setCookie('cribeon_token', '');
          setCookie('cribeon_email', '');
          window.location.href = "/";
        }
        reject(e);
      }
    });
  });
}

export async function fetchOne<Type>(
  url: string,
  params: unknown,
  login?: { auth_token: string, email: string, get_domain?: string }
) {
  return new Promise<Type>((resolve, reject) => {
    if (login) {
      v3fetch_one<Type>(
        url,
        params,
        (ob, complete_data) => {
          resolve(ob as Type);
        },
        (e) => {
          reject(new Error("Something went wrong"));
        },
        login,
      );
    } else {
      reject(new Error("User is not logged in"));
    }
  });
}